import { dispatch_theme } from '../../../config/colors';

export const margins = {
  top: {
    mt_0: {
      marginTop: 0
    },
    mt_1: {
      marginTop: dispatch_theme.spacing(1)
    },
    mt_2: {
      marginTop: dispatch_theme.spacing(2)
    },
    mt_3: {
      marginTop: dispatch_theme.spacing(3)
    },
    mt_4: {
      marginTop: dispatch_theme.spacing(4)
    },
    mt_5: {
      marginTop: dispatch_theme.spacing(5)
    },
    mt_6: {
      marginTop: dispatch_theme.spacing(6)
    },
    mt_7: {
      marginTop: dispatch_theme.spacing(7)
    }
  },
  left: {
    ml_0: {
      marginLeft: 0
    },
    ml_1: {
      marginLeft: dispatch_theme.spacing(1)
    },
    ml_2: {
      marginLeft: dispatch_theme.spacing(2)
    },
    ml_3: {
      marginLeft: dispatch_theme.spacing(3)
    },
    ml_4: {
      marginLeft: dispatch_theme.spacing(4)
    },
    ml_5: {
      marginLeft: dispatch_theme.spacing(5)
    },
    ml_6: {
      marginLeft: dispatch_theme.spacing(6)
    },
    ml_7: {
      marginLeft: dispatch_theme.spacing(7)
    }
  },
  right: {
    mr_0: {
      marginRight: 0
    },
    mr_1: {
      marginRight: dispatch_theme.spacing(1)
    },
    mr_2: {
      marginRight: dispatch_theme.spacing(2)
    },
    mr_3: {
      marginRight: dispatch_theme.spacing(3)
    },
    mr_4: {
      marginRight: dispatch_theme.spacing(4)
    },
    mr_5: {
      marginRight: dispatch_theme.spacing(5)
    },
    mr_6: {
      marginRight: dispatch_theme.spacing(6)
    },
    mr_7: {
      marginRight: dispatch_theme.spacing(7)
    }
  },
  bottom: {
    mb_0: {
      marginBottom: 0
    },
    mb_1: {
      marginBottom: dispatch_theme.spacing(1)
    },
    mb_2: {
      marginBottom: dispatch_theme.spacing(2)
    },
    mb_3: {
      marginBottom: dispatch_theme.spacing(3)
    },
    mb_4: {
      marginBottom: dispatch_theme.spacing(4)
    },
    mb_5: {
      marginBottom: dispatch_theme.spacing(5)
    },
    mb_6: {
      marginBottom: dispatch_theme.spacing(6)
    },
    mb_7: {
      marginBottom: dispatch_theme.spacing(7)
    }
  },
  all: {
    m_0: {
      margin: 0
    },
    m_1: {
      margin: dispatch_theme.spacing(1)
    },
    m_2: {
      margin: dispatch_theme.spacing(2)
    },
    m_3: {
      margin: dispatch_theme.spacing(3)
    },
    m_4: {
      margin: dispatch_theme.spacing(4)
    },
    m_5: {
      margin: dispatch_theme.spacing(5)
    },
    m_6: {
      margin: dispatch_theme.spacing(6)
    },
    m_7: {
      margin: dispatch_theme.spacing(7)
    },
    m_8: {
      margin: dispatch_theme.spacing(8)
    }
  }
};

export const paddings = {
  all: {
    p_0: {
      padding: 0
    },
    p_1: {
      padding: dispatch_theme.spacing(1)
    },
    p_2: {
      padding: dispatch_theme.spacing(2)
    },
    p_3: {
      padding: dispatch_theme.spacing(3)
    },
    p_4: {
      padding: dispatch_theme.spacing(4)
    },
    p_5: {
      padding: dispatch_theme.spacing(5)
    },
    p_6: {
      padding: dispatch_theme.spacing(6)
    },
    p_7: {
      padding: dispatch_theme.spacing(7)
    },
    p_8: {
      padding: dispatch_theme.spacing(8)
    }
  },
  top: {
    pt_0: {
      marginTop: 0
    },
    pt_1: {
      paddingTop: dispatch_theme.spacing(1)
    },
    pt_2: {
      paddingTop: dispatch_theme.spacing(2)
    },
    pt_3: {
      paddingTop: dispatch_theme.spacing(3)
    },
    pt_4: {
      paddingTop: dispatch_theme.spacing(4)
    },
    pt_5: {
      paddingTop: dispatch_theme.spacing(5)
    },
    pt_6: {
      paddingTop: dispatch_theme.spacing(6)
    },
    pt_7: {
      paddingTop: dispatch_theme.spacing(7)
    }
  },
  left: {
    pl_0: {
      paddingLeft: 0
    },
    pl_1: {
      paddingLeft: dispatch_theme.spacing(1)
    },
    pl_2: {
      paddingLeft: dispatch_theme.spacing(2)
    },
    pl_3: {
      paddingLeft: dispatch_theme.spacing(3)
    },
    pl_4: {
      paddingLeft: dispatch_theme.spacing(4)
    },
    pl_5: {
      paddingLeft: dispatch_theme.spacing(5)
    },
    pl_6: {
      paddingLeft: dispatch_theme.spacing(6)
    },
    pl_7: {
      paddingLeft: dispatch_theme.spacing(7)
    }
  },
  right: {
    pr_0: {
      paddingRight: 0
    },
    pr_1: {
      paddingRight: dispatch_theme.spacing(1)
    },
    pr_2: {
      paddingRight: dispatch_theme.spacing(2)
    },
    pr_3: {
      paddingRight: dispatch_theme.spacing(3)
    },
    pr_4: {
      paddingRight: dispatch_theme.spacing(4)
    },
    pr_5: {
      paddingRight: dispatch_theme.spacing(5)
    },
    pr_6: {
      paddingRight: dispatch_theme.spacing(6)
    },
    pr_7: {
      paddingRight: dispatch_theme.spacing(7)
    }
  },
  bottom: {
    pb_0: {
      paddingBottom: 0
    },
    pb_1: {
      paddingBottom: dispatch_theme.spacing(1)
    },
    pb_2: {
      paddingBottom: dispatch_theme.spacing(2)
    },
    pb_3: {
      paddingBottom: dispatch_theme.spacing(3)
    },
    pb_4: {
      paddingBottom: dispatch_theme.spacing(4)
    },
    pb_5: {
      paddingBottom: dispatch_theme.spacing(5)
    },
    pb_6: {
      paddingBottom: dispatch_theme.spacing(6)
    },
    pb_7: {
      paddingBottom: dispatch_theme.spacing(7)
    }
  }
};
